// src/components/ProtectedRoute.jsx

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useWallet } from './SignedWalletProvider'; // Adjust the import path

export const ProtectedRoute = ({ children }) => {
  const { jwtToken, isLoading } = useWallet();
  const location = useLocation();

  // 1. Handle the initial loading state
  // While the SignedWalletProvider is checking localStorage for a token, we don't know the auth status.
  // It's best to show a loading indicator to prevent a flicker effect.
  if (isLoading && !jwtToken) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <h2>Loading authentication status...</h2>
      </div>
    );
  }

  // 2. Check for the authentication token
  // If loading is finished and there's no token, redirect to the login page.
  if (!jwtToken) {
    // We use the `replace` prop to avoid adding the login route to the user's history,
    // so they can't click "back" to get to the protected route.
    // We also pass the original location in the state so we can redirect back after login.
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // 3. If the token exists, render the child component
  // The `children` prop will be the page component you want to protect (e.g., <Dashboard />).
  return children;
};